import { useObjectGet } from '../api/object'

export function BrandFormatter({ id }: { id?: string | null }) {
	const { data: brand } = useObjectGet('brand', id)

	if (!id) return <em className="text-gray-400">nevyplněno</em>

	return <>{brand?.name}</>
}

export function BrandLinkFormatter({ id, suffix }: { id?: string | null; suffix: string }) {
	const { data: brand } = useObjectGet('brand', id)

	if (!suffix || !id || !brand?.url_nabidek) return <em className="text-gray-400">-</em>

	return (
		<a
			href={brand.url_nabidek + suffix}
			target="_blank"
			rel="noreferrer noopener"
			className="text-blue-700 hover:underline"
		>
			{brand.url_nabidek + suffix} ⤴
		</a>
	)
}
